import React, { useState } from 'react';
import { Layers, Search, Filter, Download, Plus, ArrowRight } from 'lucide-react';
import { ItemMaster } from './ItemMaster';
const categories = ['Food Master', 'Liquor Master', 'Beer & Wine Master', 'N/A Beverage Master', 'Paper & Plastic Master'];
export function CategoryMasters() {
  const [activeTab, setActiveTab] = useState(categories[0]);
  return <div className="space-y-6" data-id="element-448">
      <div className="flex items-center gap-4 border-b border-slate-100 overflow-x-auto no-scrollbar" data-id="element-449">
        {categories.map(cat => <button key={cat} onClick={() => setActiveTab(cat)} className={`px-4 py-3 text-sm font-bold whitespace-nowrap border-b-2 transition-all ${activeTab === cat ? 'border-emerald-500 text-emerald-600' : 'border-transparent text-slate-400 hover:text-slate-600'}`} data-id="element-450">
            {cat}
          </button>)}
      </div>

      <div className="bg-emerald-50/50 p-4 rounded-2xl border border-emerald-100 flex items-center justify-between" data-id="element-451">
        <div className="flex items-center gap-3" data-id="element-452">
          <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center text-emerald-600 shadow-sm" data-id="element-453">
            <Layers size={20} data-id="element-454" />
          </div>
          <div data-id="element-455">
            <h4 className="text-sm font-bold text-slate-900" data-id="element-456">
              {activeTab} View
            </h4>
            <p className="text-[10px] text-slate-500 font-medium uppercase tracking-wider" data-id="element-457">
              Filtered by category
            </p>
          </div>
        </div>
        <div className="flex items-center gap-4" data-id="element-458">
          <div className="text-right" data-id="element-459">
            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-460">
              Total Value
            </p>
            <p className="text-lg font-black text-slate-900" data-id="element-461">$12,450.00</p>
          </div>
          <div className="h-8 w-[1px] bg-emerald-200" data-id="element-462" />
          <div className="text-right" data-id="element-463">
            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-464">
              Items
            </p>
            <p className="text-lg font-black text-slate-900" data-id="element-465">42</p>
          </div>
        </div>
      </div>

      {/* Reuse ItemMaster but with fixed category filter */}
      <ItemMaster data-id="element-466" />
    </div>;
}